import { useMemo } from 'react';

import { useBookmakersAll } from './useBookmakersAll';

export const useNonFavouritedSportsBooks = () => {
  const allBookmakers = useBookmakersAll();
  return useMemo(
    () => allBookmakers.filter(bookmaker => bookmaker.type.toLowerCase() === 'traditional'),
    [allBookmakers],
  );
};
